import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-dropzone',
  standalone: true,
  templateUrl: './file-dropzone.component.html',
  styleUrl: './file-dropzone.component.css'
})
export class FileDropzoneComponent {
  @Input() accept = 'image/*';
  @Input() multiple = true;
  @Input() title = 'Drop files here';
  @Input() hint = 'or click to browse';

  @Output() readonly filesSelected = new EventEmitter<File[]>();

  protected isDragOver = false;

  protected onNativeChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.emitFiles(input.files);
    input.value = '';
  }

  protected onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  protected onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }

  protected onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    this.emitFiles(event.dataTransfer?.files ?? null);
  }

  private emitFiles(fileList: FileList | null): void {
    if (!fileList?.length) {
      return;
    }

    this.filesSelected.emit(Array.from(fileList));
  }
}
